import { combineReducers } from 'redux'

import { reducer as router } from './modules/router'
import { reducer as fileupload } from './modules/fileupload'
import { reducer as system } from './modules/system'
import { reducer as snackbar } from './modules/snackbar'
import { reducer as network } from './modules/network'
import { reducer as user } from './modules/user'
import { reducer as project } from './modules/project'
import { reducer as resource } from './modules/resource'
import { reducer as client } from './modules/client'
import { reducer as quote } from './modules/quote'
import { reducer as payment } from './modules/payment'

const reducers = {
  router,
  fileupload,
  system,
  snackbar,
  network,
  user,
  project,
  resource,
  client,
  quote,
  payment,
}

export default combineReducers(reducers)
